<template>
  <div class="exit-box" :class="{'collapse':collapse}">
    <transition name="exitFade">
      <div class="exit-con">
        <div class="user-avatar-box">
            <img src="@/assets/avatar.jpg" class="user-avatar">
        </div>
        <!-- <el-tooltip class="item" effect="dark" :content="name" placement="top-start"> -->
        <div class="user-name ellipsis">{{userinfo.nickname}}</div>
        <!-- </el-tooltip> -->
        <img src="@/assets/exit.png" alt="" class="user-exit" @click="logout">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      userinfo: {
        avatar: localStorage.getItem('avatar'),
        nickname: localStorage.getItem('nickname')
      }
    }
  },
  methods: {
    async logout () {
      await this.$confirm('ءسىز باسقارۋ جۇيەسىنەن شەگىنەسىزبە؟', 'ەسكەرتۋ', {
        confirmButtonText: 'جارايدى',
        cancelButtonText: 'قالدىرۋ',
        type: 'warning',
        showClose: false,
        customClass: 'kzFont rtl'
      })

      localStorage.removeItem('token')
      localStorage.removeItem('nickname')
      localStorage.removeItem('avatar')
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>
<style lang="scss" scoped>
.exitFade-enter-active {
  transition: opacity 1.5s;
}

.exitFade-enter,
.exitFade-leave-to {
  opacity: 0;
}
.exit-box{
  .exit-con{
    cursor: pointer;
    height: 70px;
    border-top: 1px solid #393c43;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 0 20px;
    .user-avatar-box{
      width: 34px;
      height: 34px;
      .user-avatar{
        width: 34px;
        height: 34px;
        border-radius: 50%;
      }
    }
    .user-name{
      padding: 0 12px;
      font-size: 14px;
      color: #aeb5c4;
      // border-right: 1px solid #aeb5c4;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
    .user-exit{
      width: 18px;
      height: 14px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
}
.collapse{
   .exit-con{
     width: 64px;
     height: 100px;
     flex-flow: column;
     justify-content: center;
     .user-name{
       max-width: 70px;
       margin-top: 7px;
       border-right: 0;
       font-size: 12px;
     }
     .user-exit{
       margin-top: 6px;
       width: 14px;
       height: 10px;
       margin-left: 0;
       cursor: pointer;
     }
     ::v-deep .el-badge__content.is-fixed{
       top: 9px;
     }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/Exit.vue